import navigationRoutes from "./navigationRoutes";
import PP_Dashboard from "@/project/propertyPortal/components/PP_Dashboard";
import PP_CreateProperty from "@/project/propertyPortal/components/PP_CreateProperty";
import PP_EditRehabEstimator from "@/project/propertyPortal/components/PP_EditRehabEstimator";
import PP_MaxBidCalculation from "@/project/propertyPortal/components/PP_MaxBidCalculation";
import PP_PropertyMaster from "@/project/propertyPortal/components/PP_Properties";
import PP_ComparisonPropertyMaster from "@/project/propertyPortal/components/PP_ComparisonPropertyMaster";
import PP_EditMaxBidCalculationTable from "@/project/propertyPortal/components/PP_EditMaxBid";
import PP_RehabEstimator from "@/project/propertyPortal/components/PP_RehabEstimator";
import PP_Login from "@/project/propertyPortal/components/PP_Login";
import PP_Reports from "@/project/propertyPortal/components/PP_Reports";
import PP_MyProperty from "@/project/propertyPortal/components/PP_MyProperty";
import PP_NotFound from "@/project/propertyPortal/components/PP_NotFound";
import PP_EditComparisonProperty from "@/project/propertyPortal/components/PP_EditComparisonProperty";
import PP_EditMyProperty from "@/project/propertyPortal/components/PP_EditMyProperty";
import PP_ImportProperty from "@/project/propertyPortal/components/PP_Properties/Import";
import PP_ImportantWebsite from "@/project/propertyPortal/components/PP_ImportantWebsite";
// Unauthenticated routes (Public)
const publicRoutes = [
  {
    path: navigationRoutes.LOGIN,
    element: PP_Login,
    name: "Login",
  },
];

// Protected routes (Authenticated)
const protectedRoutes = [
  {
    path: navigationRoutes.CREATE_PROPERTY,
    element: PP_CreateProperty,
    name: "Create Property",
  },
  {
    path: navigationRoutes.CREATE_REHAB_ESTIMATOR,
    element: PP_RehabEstimator,
    name: "Create Rehab Estimator",
  },
  {
    path: navigationRoutes.MAX_BID_CALCULATION,
    element: PP_MaxBidCalculation,
    name: "Max Bid Calculation",
  },
  {
    path: navigationRoutes.MAX_BID_CALCULATION_TABLE,
    element: PP_MaxBidCalculation,
    name: "Max Bid Calculation Table",
  },
  {
    path: navigationRoutes.PROPERTY_MASTER,
    element: PP_PropertyMaster,
    name: "Property Master",
  },
  {
    path: navigationRoutes.IMPORT_PROPERTY,
    element: PP_ImportProperty,
    name: "Import Property",
  },
  {
    path: navigationRoutes.COMPARISON_PROPERTY_MASTER,
    element: PP_ComparisonPropertyMaster,
    name: "Comparison Property Master",
  },
  {
    path: navigationRoutes.REHAB_ESTIMATOR,
    element: PP_RehabEstimator,
    name: "Rehab Estimator",
  },
  {
    path: navigationRoutes.REPORTS,
    element: PP_Reports,
    name: "Reports",
  },
  {
    path: navigationRoutes.MY_PROPERTY,
    element: PP_MyProperty,
    name: "My Property",
  },
  {
    path: navigationRoutes.DASHBOARD,
    element: PP_Dashboard,
    name: "Dashboard",
  },
  {
    path: navigationRoutes.IMPORTANT_WEBSITE,
    element: PP_ImportantWebsite,
    name: "Important Website",
  },
  {
    path: navigationRoutes.EDIT_PROPERTY,
    element: PP_CreateProperty,
    name: "Edit Property",
  },
  {
    path: navigationRoutes.EDIT_COMPARISON_PROPERTY,
    element: PP_EditComparisonProperty,
    name: "Edit Comparison Property",
  },
  {
    path: navigationRoutes.EDIT_MAX_BID_CALCULATION,
    element: PP_EditMaxBidCalculationTable,
    name: "Edit Max Bid Calculation",
  },
  {
    path: navigationRoutes.EDIT_REHAB_ESTIMATOR,
    element: PP_EditRehabEstimator,
    name: "Edit Rehab Estimator",
  },
  {
    path: navigationRoutes.EDIT_MY_PROPERTY,
    element: PP_EditMyProperty,
    name: "Edit My Property",
  },
  {
    path: "*",
    element: PP_NotFound,
    name: "Not Found",
  },
];

const routes = [
  { type: "public", routes: publicRoutes },
  { type: "auth", routes: protectedRoutes },
];

export default routes;
